import React, {useCallback, useRef} from 'react';
import { Flex, GridItem } from '@chakra-ui/react';
import { StyledGrid } from "../../../components/Styled/StyledComponents";
import { ButtonStack, CustomButton } from "../../../components/Styled/StyledButtons";
import { Icon } from "@iconify/react";
import PaymentsSearchFilter from "./PaymentsSearchFilter";
import moment from "moment/moment";
import {exportFilteredPayments, exportPayments} from "../PaymentsAPI";
import Papa from 'papaparse';

const PaymentsTableTopBar = ({ setPageNumber, setFilterOptions, setFetchTrigger }) => {
    const filterRef = useRef({});

    const handleFilterChange = useCallback(async (newFilterOptions) => {
        setPageNumber(1);
        // await new Promise(resolve => setTimeout(resolve, 0));
        filterRef.current = newFilterOptions;
        setFilterOptions(newFilterOptions);
        setFetchTrigger(f => !f);
    }, [setPageNumber, setFilterOptions, setFetchTrigger]);


    const downloadCSV = (data, filenamePrefix) => {
        const adjustedData = data?.map(entry => {
            const copy = { ...entry };

            if (copy.createdDate) {
                const formatted = moment
                    .utc(copy.createdDate)
                    .tz('Africa/Gaborone')
                    .format('DD-MM-YYYY hh:mm:ss');
                copy.createdDate = `="${formatted}"`;
            }

            if (copy.editedDate) {
                const formatted = moment
                    .utc(copy.editedDate)
                    .tz('Africa/Gaborone')
                    .format('DD-MM-YYYY hh:mm:ss');
                copy.editedDate = `="${formatted}"`;
            }

            return copy;
        });

        const csv = Papa.unparse(adjustedData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${filenamePrefix}-${moment().format('DD-MM-YYYY')}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    const handleExportClick = async () => {
        try {
            const data = await exportFilteredPayments(filterRef.current);
            downloadCSV(data, 'WUC-online-payments');
        } catch (error) {
            console.error("Error exporting payments:", error);
        }
    };

    const handleExportAllClick = async () => {
        try {
            const data = await exportPayments();
            downloadCSV(data, 'WUC-all-payments');
        } catch (error) {
            console.error("Error exporting all payments:", error);
        }
    };

    return (
        <>
            <StyledGrid templateColumns="repeat(12, 1fr)">
                <GridItem colSpan={{ base: 10, md: 11 }}>
                    <PaymentsSearchFilter onFilterChange={handleFilterChange} />
                </GridItem>
                <GridItem colSpan={{ base: 12, md: 1 }}>
                    <ButtonStack direction="row">
                        {Object.values(filterRef.current).some(val => val) ? (
                            <CustomButton
                                type="addNew"
                                showIcon
                                showTooltip
                                tooltipLabel="Export Filtered CSV"
                                icon={<Icon icon="ph:file-csv-light" />}
                                onClick={handleExportClick}
                            >
                                Export Filtered
                            </CustomButton>
                        ) : (
                            <CustomButton
                                type="addNew"
                                showIcon
                                showTooltip
                                tooltipLabel="Export All CSV"
                                icon={<Icon icon="ph:file-csv-light" />}
                                onClick={handleExportAllClick}
                            >
                                Export All
                            </CustomButton>
                        )}
                    </ButtonStack>
                </GridItem>
            </StyledGrid>
            <Flex bg="white" mb={4} h="1px" />
        </>
    );
};

export default PaymentsTableTopBar;

